import React from "react";
import logo from "@/assets/logo/sponsors.gif";

const Footer: React.FC = () => (
  <div className="flex items-center bg-[#05336B] px-[21px] text-[32px] font-semibold text-white h-24">
    <div>Ивээн тэтгэгч:</div>
    <img src={logo} alt="sponsors" />
  </div>
);

export default Footer;
